import styled, { css } from 'styled-components';
import { EntityStyledProps } from './types';
import { Box } from '@bechtel/gds';

export const EntityStyled = styled(Box).attrs({
  p: { sm: '450' },
  flexDirection: { sm: 'column' },
  gap: { sm: '400' },
})<EntityStyledProps>`
  ${({ theme, active }) => css`
    cursor: pointer;
    width: 92px;
    border: 1px solid ${theme.colors.grey[300]};
    border-radius: ${theme.radii[200]};
    ${active
      ? `background-color:${theme.colors.bechtel.blue[700]};color:${theme.colors.white};`
      : `background-color:${theme.colors.white};`}
  `}
`;
